import { I18n } from "i18n-js";
import translations from "../locale";

export const i18n = new I18n();
i18n.store(translations);
i18n.defaultLocale = "en";
i18n.enableFallback = true;
